import type { AthenaPrincipal } from "../../../runtime/data/principal.ts";
import { billingSubjectNotFound } from "../../subject/errors.ts";
import type { BillingSqlExecutor } from "../../subject/repository.ts";
import type { BillingPage } from "../types.ts";
import type { BillingPayment } from "../../types.ts";
import { clampSelfListLimit } from "./invoices.ts";

const LIST_OWNED_PAYMENTS_SQL = `
SELECT *
FROM billing.billing_payments
WHERE subject_kind = $1
  AND subject_id = $2
  AND ownership_status = 'resolved'
ORDER BY ingested_at DESC
LIMIT $3
`;

const GET_OWNED_PAYMENT_SQL = `
SELECT *
FROM billing.billing_payments
WHERE id = $1
  AND subject_kind = $2
  AND subject_id = $3
  AND ownership_status = 'resolved'
`;

function asPayment(row: Record<string, unknown>): BillingPayment {
	return {
		amount: {
			currency: typeof row.amount_currency === "string" ? row.amount_currency : "EUR",
			value: String(row.amount_value ?? "0"),
		},
		metadata: row.metadata ?? {},
		provider: row.provider === "stripe" ? "stripe" : "mollie",
		providerPaymentId: String(row.provider_payment_id ?? ""),
		raw: row.raw ?? {},
		status: String(row.status ?? "pending"),
	} as BillingPayment;
}

export async function listSelfPayments(input: {
	limit?: number;
	principal: AthenaPrincipal;
	sql: BillingSqlExecutor;
}): Promise<BillingPage<BillingPayment>> {
	const result = await input.sql.query(LIST_OWNED_PAYMENTS_SQL, [
		"user",
		input.principal.userId,
		clampSelfListLimit(input.limit),
	]);
	return { items: result.rows.map(asPayment) };
}

export async function getSelfPayment(input: {
	paymentId: string;
	principal: AthenaPrincipal;
	sql: BillingSqlExecutor;
}): Promise<BillingPayment> {
	const result = await input.sql.query(GET_OWNED_PAYMENT_SQL, [
		input.paymentId,
		"user",
		input.principal.userId,
	]);
	const row = result.rows[0];
	if (!row) {
		throw billingSubjectNotFound();
	}
	return asPayment(row);
}
